module.exports = __webpack_public_path__ + "static/media/video-image.b6e8410e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-image.png
// module id = ./src/assets/video-image.png
// module chunks = 2